function arrayBufferToHexString(buffer: Uint8Array): string {
  let result = '';
  for (let item of buffer) {
    let value = item.toString(16);
    if (value.length === 1)
      value = '0' + value;
    result += value;
  }
  return result;
}

export function randomHexString(length: number): string {
  const random = new Uint8Array(length);
  crypto.getRandomValues(random);
  return arrayBufferToHexString(random);
}

const MAX_INT32 = 2147483648;

export function randomInt32(): number {
  const random = new Uint32Array(1);
  crypto.getRandomValues(random);
  let result = random[0];
  if (result > MAX_INT32)
    result = result - MAX_INT32;
  return result;
}

export const clientId = randomInt32();
